module.exports = __webpack_public_path__ + "img/weibo.2f62416d.png";